import React, { useContext, useEffect } from 'react';

import { PlayerContext } from '../../../../context/player/PlayerProvider';
import { IPlayer } from '../../../../typings/hlroom';

const Player: React.FC<IPlayer> = ({ setup, eventName, clickedButton }) => {
  const { manager, onSetActivePlayer } = useContext(PlayerContext);

  const { id, onEvents } = setup;

  const containerId = `skyplayer-${id}`;

  useEffect(() => {
    const player = (manager as any).initPlayer(containerId, setup);

    Boolean(onEvents) && Object.entries(onEvents).forEach(([event, callback]) => player.on(event, callback));
    onSetActivePlayer(id.toString());

    return () => {
      Boolean(onEvents) &&
        Boolean(player) &&
        Object.entries(onEvents).forEach(([event, callback]) => player.off(event, callback));
      Boolean(player) && player.dispose();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div id={containerId} data-event={eventName} />;
};

export default Player;
